module.exports = __webpack_public_path__ + "static/media/gold.23fde17a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/gold.svg
// module id = 349
// module chunks = 21